import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { EmptyPlaceholder } from '../../../../../../shared/components/EmptyPlaceholder'
import { Fade } from '@mui/material'
import React from 'react'
import { ValueMessageLinkedData } from '../../../../../../shared/queries/useGetValueMessageLinkedDataQuery'
import SupportingEvidenceExpandedRowItem from './components/SupportingEvidenceExpandedRowItem'
import { ValueMessage } from '../../../../../ValueNarrativesView/queries/useGetValueNarrativesQuery'

type SupportingEvidenceExpandedRowProps = {
    supportingEvidence: ValueMessageLinkedData['supportingEvidence']
    keyEvidenceStatements: ValueMessageLinkedData['keyEvidenceStatements']
    navigationStack: ArrayLike<object>
    valueMessage: ValueMessage
}

const SupportingEvidenceExpandedRow = ({
    supportingEvidence,
    keyEvidenceStatements,
    navigationStack,
    valueMessage,
}: SupportingEvidenceExpandedRowProps) => {
    return (
        <Fade in timeout={800}>
            <Stack
                direction="column"
                pl={9}
                pr={4}
                py={1.5}
                borderTop="1px solid"
                borderBottom="1px solid"
                borderColor="figma.grayscale.stroke"
            >
                <Typography variant="16x700" mb={0.5}>
                    Supporting Evidence
                </Typography>

                {!supportingEvidence?.length && (
                    <Stack direction="column" alignItems="flex-start">
                        <EmptyPlaceholder text="No data to display" />
                    </Stack>
                )}

                {supportingEvidence.map((evidence, evidenceIndex) => {
                    const matchingKES = keyEvidenceStatements?.filter(
                        (kes) => kes.parentEvidence.toString() === evidence._id
                    )

                    return (
                        <Stack
                            key={evidence._id}
                            direction="column"
                            gap={1}
                            py={1.5}
                            {...(evidenceIndex !== supportingEvidence.length - 1 && {
                                borderBottom: '1px solid',
                                borderColor: 'figma.grayscale.stroke',
                                px: 1.5,
                                mx: -1.5,
                            })}
                        >
                            <SupportingEvidenceExpandedRowItem
                                navigationStack={navigationStack}
                                evidence={evidence}
                                keyEvidenceStatements={matchingKES}
                                valueMessage={valueMessage}
                            />
                        </Stack>
                    )
                })}
            </Stack>
        </Fade>
    )
}

export default SupportingEvidenceExpandedRow
